import { render, staticRenderFns } from "./_Sidebar-left.vue?vue&type=template&id=cafd4e48&scoped=true&"
import script from "./_Sidebar-left.vue?vue&type=script&lang=js&"
export * from "./_Sidebar-left.vue?vue&type=script&lang=js&"
import style0 from "./_Sidebar-left.vue?vue&type=style&index=0&id=cafd4e48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafd4e48",
  null
  
)

export default component.exports